import React from 'react'

import SignalIntentCalculator from './SignalIntentCalculator'

const HELOCCalculatorBlock = () => {
  return <SignalIntentCalculator Guid='b0fd68e9-7c84-4044-9fe8-5767de990a84' />
}

export default React.memo(HELOCCalculatorBlock)
